import { useIntl } from "react-intl";

// Todo: Remove once data is coming in from contentful
// @ts-ignore
export const useAgileHubPageTreeData = () => {
    const intl = useIntl();
    const AgileHubPageTreeData = [
        {
            key: "manifesto",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.manifesto",
                defaultMessage: "Agile manifesto"
            }),
            urlSlug: "/agile/manifesto",
            level: 0,
            isRoot: true
        },
        {
            key: "scrum",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.scrum",
                defaultMessage: "Scrum"
            }),
            urlSlug: "/agile/scrum",
            level: 0,
            isRoot: true,
            children: [
                {
                    key: "/agile/scrum",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-overview",
                        defaultMessage: "Overview"
                    }),
                    urlSlug: "/agile/scrum",
                    level: 0
                },
                {
                    key: "/agile/scrum/sprints",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-sprints",
                        defaultMessage: "Sprints"
                    }),
                    urlSlug: "/agile/scrum/sprints",
                    level: 1
                },
                {
                    key: "/agile/scrum/sprint-planning",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-sprint-planning",
                        defaultMessage: "Sprint planning"
                    }),
                    urlSlug: "/agile/scrum/sprint-planning",
                    level: 1
                },
                {
                    key: "/agile/scrum/ceremonies",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-ceremonies",
                        defaultMessage: "Ceremonies"
                    }),
                    urlSlug: "/agile/scrum/ceremonies",
                    level: 1
                },
                {
                    key: "/agile/scrum/backlogs",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-backlogs",
                        defaultMessage: "Backlogs"
                    }),
                    urlSlug: "/agile/scrum/backlogs",
                    level: 1
                },
                {
                    key: "/agile/scrum/sprint-reviews",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-sprint-reviews",
                        defaultMessage: "Sprint reviews"
                    }),
                    urlSlug: "/agile/scrum/sprint-reviews",
                    level: 1
                },
                {
                    key: "/agile/scrum/standups",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-standups",
                        defaultMessage: "Standups"
                    }),
                    urlSlug: "/agile/scrum/standups",
                    level: 1
                },
                {
                    key: "/agile/scrum/scrum-master",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-scrum-master",
                        defaultMessage: "Scrum master"
                    }),
                    urlSlug: "/agile/scrum/scrum-master",
                    level: 1
                },
                {
                    key: "/agile/scrum/retrospectives",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-retrospectives",
                        defaultMessage: "Retrospectives"
                    }),
                    urlSlug: "/agile/scrum/retrospectives",
                    level: 1
                },
                {
                    key: "/agile/scrum/distributed-scrum",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-distributed-scrum",
                        defaultMessage: "Distributed scrum"
                    }),
                    urlSlug: "/agile/scrum/distributed-scrum",
                    level: 1
                },
                {
                    key: "/agile/scrum/roles",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-roles",
                        defaultMessage: "Roles"
                    }),
                    urlSlug: "/agile/scrum/roles",
                    level: 1
                },
                {
                    key: "/agile/scrum/scrum-of-scrums",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-scrum-of-scrums",
                        defaultMessage: "Scrum of scrums"
                    }),
                    urlSlug: "/agile/scrum/scrum-of-scrums",
                    level: 1
                },
                {
                    key: "/agile/scrum/artifacts",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-artifacts",
                        defaultMessage: "Agile scrum artifacts"
                    }),
                    urlSlug: "/agile/scrum/artifacts",
                    level: 1
                },
                {
                    key: "/agile/scrum/scrum-metrics",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-scrum-metrics",
                        defaultMessage: "Scrum metrics"
                    }),
                    urlSlug: "/agile/scrum/scrum-metrics",
                    level: 1
                },
                {
                    key: "/agile/scrum/jira-confluence-scrum",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-jira-confluence-scrum",
                        defaultMessage: "Jira Confluence scrum"
                    }),
                    urlSlug: "/agile/scrum/jira-confluence-scrum",
                    level: 1
                },
                {
                    key: "/agile/scrum/agile-vs-scrum",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-agile-vs-scrum",
                        defaultMessage: "Agile vs Scrum"
                    }),
                    urlSlug: "/agile/scrum/agile-vs-scrum",
                    level: 1
                },
                {
                    key: "/agile/scrum/backlog-refinement",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-backlog-refinement",
                        defaultMessage: "Backlog Refinement Guide"
                    }),
                    urlSlug: "/agile/scrum/backlog-refinement",
                    level: 1
                },
                {
                    key: "/agile/scrum/scrum-master-project-manager",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-master-project-manager",
                        defaultMessage: "Scrum master vs. project manager"
                    }),
                    urlSlug: "/agile/scrum/scrum-master-project-manager",
                    level: 1
                }
            ]
        },
        {
            key: "kanban",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.kanban",
                defaultMessage: "Kanban"
            }),
            urlSlug: "/agile/kanban",
            level: 0,
            isRoot: true,
            children: [
                {
                    key: "/agile/kanban",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.kanban-overview",
                        defaultMessage: "Overview"
                    }),
                    urlSlug: "/agile/kanban",
                    level: 0
                },
                {
                    key: "/agile/kanban/boards",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.kanban-boards",
                        defaultMessage: "Boards"
                    }),
                    urlSlug: "/agile/kanban/boards",
                    level: 1
                },
                {
                    key: "/agile/kanban/wip-limits",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.kanban-wip-limits",
                        defaultMessage: "WIP limits"
                    }),
                    urlSlug: "/agile/kanban/wip-limits",
                    level: 1
                },
                {
                    key: "/agile/kanban/kanban-vs-scrum",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.kanban-kanban-vs-scrum",
                        defaultMessage: "Kanban vs Scrum"
                    }),
                    urlSlug: "/agile/kanban/kanban-vs-scrum",
                    level: 1
                },
                {
                    key: "/agile/kanban/kanplan",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.kanban-kanplan",
                        defaultMessage: "Kanplan"
                    }),
                    urlSlug: "/agile/kanban/kanplan",
                    level: 1
                },
                {
                    key: "/agile/kanban/cards",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.kanban-cards",
                        defaultMessage: "Kanban cards"
                    }),
                    urlSlug: "/agile/kanban/cards",
                    level: 1
                }
            ]
        },
        {
            key: "project-management",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.project-management",
                defaultMessage: "Agile project management"
            }),
            urlSlug: "/agile/project-management",
            level: 0,
            isRoot: true,
            children: [
                {
                    key: "/agile/project-management",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-overview",
                        defaultMessage: "Overview"
                    }),
                    urlSlug: "/agile/project-management",
                    level: 0
                },
                {
                    key: "/agile/project-management/project-management-intro",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-project-management-intro",
                        defaultMessage: "Project management intro"
                    }),
                    urlSlug:
                        "/agile/project-management/project-management-intro",
                    level: 1
                },
                {
                    key: "/agile/project-management/workflow",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-workflow",
                        defaultMessage: "Workflow"
                    }),
                    urlSlug: "/agile/project-management/workflow",
                    level: 1
                },
                {
                    key: "/agile/project-management/epics-stories-themes",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-epics-stories-themes",
                        defaultMessage: "Epics, stories, themes"
                    }),
                    urlSlug: "/agile/project-management/epics-stories-themes",
                    level: 1
                },
                {
                    key: "/agile/project-management/epics",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-epics",
                        defaultMessage: "Epics"
                    }),
                    urlSlug: "/agile/project-management/epics",
                    level: 1
                },
                {
                    key: "/agile/project-management/user-stories",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-user-stories",
                        defaultMessage: "User Stories"
                    }),
                    urlSlug: "/agile/project-management/user-stories",
                    level: 1
                },
                {
                    key: "/agile/project-management/estimation",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-estimation",
                        defaultMessage: "Estimation"
                    }),
                    urlSlug: "/agile/project-management/estimation",
                    level: 1
                },
                {
                    key: "/agile/project-management/metrics",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-metrics",
                        defaultMessage: "Metrics"
                    }),
                    urlSlug: "/agile/project-management/metrics",
                    level: 1
                },
                {
                    key: "/agile/project-management/gantt-chart",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-gantt-chart",
                        defaultMessage: "Gantt chart"
                    }),
                    urlSlug: "/agile/project-management/gantt-chart",
                    level: 1
                },
                {
                    key: "/agile/project-management/program-management",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-program-management",
                        defaultMessage:
                            "Program management vs. project management"
                    }),
                    urlSlug: "/agile/project-management/program-management",
                    level: 1
                },
                {
                    key: "/agile/project-management/project-baseline",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-project-baseline",
                        defaultMessage: "Project baseline"
                    }),
                    urlSlug: "/agile/project-management/project-baseline",
                    level: 1
                },
                {
                    key: "/agile/project-management/continuous-improvement",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-continuous-improvement",
                        defaultMessage: "Continuous improvement"
                    }),
                    urlSlug: "/agile/project-management/continuous-improvement",
                    level: 1
                },
                {
                    key: "/agile/project-management/lean-principles",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-lean-principles",
                        defaultMessage: "Lean principles"
                    }),
                    urlSlug: "/agile/project-management/lean-principles",
                    level: 1
                },
                {
                    key: "/agile/project-management/3-pillars-scrum",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-3-pillars-scrum",
                        defaultMessage: "3 pillars of Scrum"
                    }),
                    urlSlug: "/agile/project-management/3-pillars-scrum",
                    level: 1
                },
                {
                    key: "/agile/project-management/scrum-board",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-scrum-board",
                        defaultMessage: "Scrum Board"
                    }),
                    urlSlug: "/agile/project-management/scrum-board",
                    level: 1
                },
                {
                    key: "/agile/project-management/waterfall-methodology",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-waterfall-methodology",
                        defaultMessage: "Waterfall Methodology"
                    }),
                    urlSlug: "/agile/project-management/waterfall-methodology",
                    level: 1
                },
                {
                    key: "/agile/project-management/velocity-scrum",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-velocity-scrum",
                        defaultMessage: "Velocity in Scrum"
                    }),
                    urlSlug: "/agile/project-management/velocity-scrum",
                    level: 1
                },
                {
                    key: "/agile/project-management/definition-of-ready",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-definition-of-ready",
                        defaultMessage: "What is Definition of Ready"
                    }),
                    urlSlug: "/agile/project-management/definition-of-ready",
                    level: 1
                },
                {
                    key: "/agile/project-management/lean-vs-agile",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-lean-vs-agile",
                        defaultMessage: "Lean vs. agile"
                    }),
                    urlSlug: "/agile/project-management/lean-vs-agile",
                    level: 1
                },
                {
                    key: "/agile/project-management/scrumban",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-scrumban",
                        defaultMessage: "Scrumban"
                    }),
                    urlSlug: "/agile/project-management/scrumban",
                    level: 1
                },
                {
                    key: "/agile/project-management/lean-methodology",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-lean-methodology",
                        defaultMessage: "Lean Methodology"
                    }),
                    urlSlug: "/agile/project-management/lean-methodology",
                    level: 1
                },
                {
                    key: "/agile/project-management/sprint-backlog",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-sprint-backlog",
                        defaultMessage: "Sprint backlog"
                    }),
                    urlSlug: "/agile/project-management/sprint-backlog",
                    level: 1
                },
                {
                    key: "/agile/project-management/burn-up-chart",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-burn-up-chart",
                        defaultMessage: "Burn up chart"
                    }),
                    urlSlug: "/agile/project-management/burn-up-chart",
                    level: 1
                },
                {
                    key: "/agile/project-management/kanban-principles",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-kanban-principles",
                        defaultMessage: "4 kanban principles"
                    }),
                    urlSlug: "/agile/project-management/kanban-principles",
                    level: 1
                },
                {
                    key: "/agile/project-management/kanban-metrics",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-kanban-metrics",
                        defaultMessage: "4 kanban metrics"
                    }),
                    urlSlug: "/agile/project-management/kanban-metrics",
                    level: 1
                },
                {
                    key: "/agile/project-management/program-vs-project-manager",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-program-vs-project-manager",
                        defaultMessage: "Program vs. Project Manager"
                    }),
                    urlSlug:
                        "/agile/project-management/program-vs-project-manager",
                    level: 1
                },
                {
                    key: "/agile/project-management/gantt-chart-examples",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-gantt-chart-examples",
                        defaultMessage: "Gantt chart examples"
                    }),
                    urlSlug: "/agile/project-management/gantt-chart-examples",
                    level: 1
                },
                {
                    key: "/agile/project-management/definition-of-done",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-definition-of-done",
                        defaultMessage: "Definition of done"
                    }),
                    urlSlug: "/agile/project-management/definition-of-done",
                    level: 1
                },
                {
                    key: "/agile/project-management/backlog-grooming",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-backlog-grooming",
                        defaultMessage: "Backlog grooming"
                    }),
                    urlSlug: "/agile/project-management/backlog-grooming",
                    level: 1
                },
                {
                    key: "/agile/project-management/lean-process-improvement",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-lean-process-improvement",
                        defaultMessage: "Lean process improvement"
                    }),
                    urlSlug:
                        "/agile/project-management/lean-process-improvement",
                    level: 1
                },
                {
                    key: "/agile/project-management/backlog-refinement-meeting",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-backlog-refinement-meeting",
                        defaultMessage: "Backlog refinement meetings"
                    }),
                    urlSlug:
                        "/agile/project-management/backlog-refinement-meeting",
                    level: 1
                },
                {
                    key: "/agile/project-management/scrum-values",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-scrum-values",
                        defaultMessage: "Scrum values"
                    }),
                    urlSlug: "/agile/project-management/scrum-values",
                    level: 1
                },
                {
                    key: "/agile/project-management/scope-of-work",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-scope-of-work",
                        defaultMessage: "Scope of work"
                    }),
                    urlSlug: "/agile/project-management/scope-of-work",
                    level: 1
                },
                {
                    key: "/agile/project-management/scrum-tools",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-scrum-tools",
                        defaultMessage: "Scrum tools"
                    }),
                    urlSlug: "/agile/project-management/scrum-tools",
                    level: 1
                },
                {
                    key: "/agile/project-management/tools",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-tools",
                        defaultMessage: "Tools"
                    }),
                    urlSlug: "/agile/project-management/tools",
                    level: 1
                },
                {
                    key: "/agile/project-management/workflow-automation-software",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-workflow-automation-software",
                        defaultMessage: "Workflow automation software"
                    }),
                    urlSlug:
                        "/agile/project-management/workflow-automation-software",
                    level: 1
                },
                {
                    key: "/agile/project-management/templates",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-templates",
                        defaultMessage: "Templates"
                    }),
                    urlSlug: "/agile/project-management/templates",
                    level: 1
                },
                {
                    key: "/agile/project-management/task-tracker",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-task-tracker",
                        defaultMessage: "Task tracker"
                    }),
                    urlSlug: "/agile/project-management/task-tracker",
                    level: 1
                },
                {
                    key: "/agile/project-management/workflow-automation",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-workflow-automation",
                        defaultMessage: "Workflow automation"
                    }),
                    urlSlug: "/agile/project-management/workflow-automation",
                    level: 1
                },
                {
                    key: "/agile/project-management/status-report",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-status-report",
                        defaultMessage: "Status report"
                    }),
                    urlSlug: "/agile/project-management/status-report",
                    level: 1
                },
                {
                    key: "/agile/project-management/workflow-chart",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-workflow-chart",
                        defaultMessage: "Workflow chart"
                    }),
                    urlSlug: "/agile/project-management/workflow-chart",
                    level: 1
                },
                {
                    key: "/agile/project-management/project-roadmap",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-project-roadmap",
                        defaultMessage: "Project roadmap"
                    }),
                    urlSlug: "/agile/project-management/project-roadmap",
                    level: 1
                },
                {
                    key: "/agile/project-management/project-schedule",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-project-schedule",
                        defaultMessage: "Project schedule"
                    }),
                    urlSlug: "/agile/project-management/project-schedule",
                    level: 1
                },
                {
                    key: "/agile/project-management/issue-tracking-software",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-issue-tracking-software",
                        defaultMessage: "Tracking software"
                    }),
                    urlSlug:
                        "/agile/project-management/issue-tracking-software",
                    level: 1
                },
                {
                    key: "/agile/project-management/roadmap-tools",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-roadmap-tools",
                        defaultMessage: "Roadmap tools"
                    }),
                    urlSlug: "/agile/project-management/roadmap-tools",
                    level: 1
                },
                {
                    key: "/agile/project-management/technology-roadmap",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-technology-roadmap",
                        defaultMessage: "Technology roadmap"
                    }),
                    urlSlug: "/agile/project-management/technology-roadmap",
                    level: 1
                },
                {
                    key: "/agile/project-management/project-scheduling-software",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-project-scheduling-software",
                        defaultMessage: "Project scheduling software"
                    }),
                    urlSlug:
                        "/agile/project-management/project-scheduling-software",
                    level: 1
                },
                {
                    key: "/agile/project-management/backlog-management-tools",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-backlog-management-tools",
                        defaultMessage: "Backlog management tools"
                    }),
                    urlSlug:
                        "/agile/project-management/backlog-management-tools",
                    level: 1
                },
                {
                    key: "/agile/project-management/workflow-management",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-workflow-management",
                        defaultMessage:
                            "Understanding workflow management strategies"
                    }),
                    urlSlug: "/agile/project-management/workflow-management",
                    level: 1
                },
                {
                    key: "/agile/project-management/workflow-examples",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-workflow-examples",
                        defaultMessage: "Workflow examples"
                    }),
                    urlSlug: "/agile/project-management/workflow-examples",
                    level: 1
                },
                {
                    key: "/agile/project-management/create-project-roadmap",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-create-project-roadmap",
                        defaultMessage: "Create project roadmap"
                    }),
                    urlSlug: "/agile/project-management/create-project-roadmap",
                    level: 1
                },
                {
                    key: "/agile/project-management/sprint-planning-tools",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-sprint-planning-tools",
                        defaultMessage: "Sprint planning tools"
                    }),
                    urlSlug: "/agile/project-management/sprint-planning-tools",
                    level: 1
                },
                {
                    key: "/agile/project-management/sprint-demo",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-sprint-demo",
                        defaultMessage: "Sprint demo"
                    }),
                    urlSlug: "/agile/project-management/sprint-demo",
                    level: 1
                },
                {
                    key: "/agile/project-management/project-timeline-software",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-project-timeline-software",
                        defaultMessage: "Project Timeline Software"
                    }),
                    urlSlug:
                        "/agile/project-management/project-timeline-software",
                    level: 1
                },
                {
                    key: "/agile/project-management/task-management-tools",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-task-management-tools",
                        defaultMessage: "Top task management tools"
                    }),
                    urlSlug: "/agile/project-management/task-management-tools",
                    level: 1
                },
                {
                    key: "/agile/project-management/sprint-backlog-product-backlog",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-sprint-backlog-product-backlog",
                        defaultMessage: "Product backlog vs. sprint backlog"
                    }),
                    urlSlug:
                        "/agile/project-management/sprint-backlog-product-backlog",
                    level: 1
                },
                {
                    key: "/agile/project-management/workflow-management-tools",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-workflow-management-tools",
                        defaultMessage: "Top workflow management tools"
                    }),
                    urlSlug:
                        "/agile/project-management/workflow-management-tools",
                    level: 1
                },
                {
                    key: "/agile/project-management/project-management-dependencies",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-project-management-dependencies",
                        defaultMessage: "Project dependencies"
                    }),
                    urlSlug:
                        "/agile/project-management/project-management-dependencies",
                    level: 1
                },
                {
                    key: "/agile/project-management/task-management-dashboard",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-task-management-dashboard",
                        defaultMessage: "Task dashboard guide"
                    }),
                    urlSlug:
                        "/agile/project-management/task-management-dashboard",
                    level: 1
                },
                {
                    key: "/agile/project-management/sprint-cadence",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-sprint-cadence",
                        defaultMessage: "Sprint cadence"
                    }),
                    urlSlug: "/agile/project-management/sprint-cadence",
                    level: 1
                },
                {
                    key: "/agile/project-management/fast-tracking",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-fast-tracking",
                        defaultMessage: "Fast tracking"
                    }),
                    urlSlug: "/agile/project-management/fast-tracking",
                    level: 1
                }
            ]
        },
        {
            key: "product-management",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.product-management",
                defaultMessage: "Product Management"
            }),
            urlSlug: "/agile/product-management",
            level: 0,
            isRoot: true,
            children: [
                {
                    key: "/agile/product-management",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-overview",
                        defaultMessage: "Overview"
                    }),
                    urlSlug: "/agile/product-management",
                    level: 0
                },
                {
                    key: "/agile/product-management/product-roadmaps",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-roadmaps",
                        defaultMessage: "Product Roadmaps"
                    }),
                    urlSlug: "/agile/product-management/product-roadmaps",
                    level: 1
                },
                {
                    key: "/agile/product-management/product-manager",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-manager",
                        defaultMessage: "Product Manager"
                    }),
                    urlSlug: "/agile/product-management/product-manager",
                    level: 1
                },
                {
                    key: "/agile/product-management/tips-for-new-product-manager",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-tips-for-new-product-manager",
                        defaultMessage: "Tips for new product managers"
                    }),
                    urlSlug:
                        "/agile/product-management/tips-for-new-product-manager",
                    level: 1
                },
                {
                    key: "/agile/product-management/roadmaps",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-roadmaps",
                        defaultMessage: "Roadmaps"
                    }),
                    urlSlug: "/agile/product-management/roadmaps",
                    level: 1
                },
                {
                    key: "/agile/product-management/tips-for-presenting-product-roadmaps",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-tips-for-presenting-product-roadmaps",
                        defaultMessage: "Tips for presenting product roadmaps"
                    }),
                    urlSlug:
                        "/agile/product-management/tips-for-presenting-product-roadmaps",
                    level: 1
                },
                {
                    key: "/agile/product-management/requirements",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-requirements",
                        defaultMessage: "Requirements"
                    }),
                    urlSlug: "/agile/product-management/requirements",
                    level: 1
                },
                {
                    key: "/agile/product-management/product-analytics",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-analytics",
                        defaultMessage: "Product analytics"
                    }),
                    urlSlug: "/agile/product-management/product-analytics",
                    level: 1
                },
                {
                    key: "/agile/product-management/product-development",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-development",
                        defaultMessage: "Product development"
                    }),
                    urlSlug: "/agile/product-management/product-development",
                    level: 1
                },
                {
                    key: "/agile/product-management/remote-product-management",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-remote-product-management",
                        defaultMessage: "Remote product management"
                    }),
                    urlSlug:
                        "/agile/product-management/remote-product-management",
                    level: 1
                },
                {
                    key: "/agile/product-management/minimum-viable-product",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-minimum-viable-product",
                        defaultMessage: "Minimal viable product"
                    }),
                    urlSlug: "/agile/product-management/minimum-viable-product",
                    level: 1
                },
                {
                    key: "/agile/product-management/discovery",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-discovery",
                        defaultMessage: "Product discovery"
                    }),
                    urlSlug: "/agile/product-management/discovery",
                    level: 1
                },
                {
                    key: "/agile/product-management/product-specification",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-specification",
                        defaultMessage: "Product specification"
                    }),
                    urlSlug: "/agile/product-management/product-specification",
                    level: 1
                },
                {
                    key: "/agile/product-management/product-development-strategy",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-development-strategy",
                        defaultMessage: "Product development strategy"
                    }),
                    urlSlug:
                        "/agile/product-management/product-development-strategy",
                    level: 1
                },
                {
                    key: "/agile/product-management/product-development-software",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-development-software",
                        defaultMessage: "Product development software"
                    }),
                    urlSlug:
                        "/agile/product-management/product-development-software",
                    level: 1
                },
                {
                    key: "/agile/product-management/new-product-development-process",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-new-product-development-process",
                        defaultMessage: "New product development process"
                    }),
                    urlSlug:
                        "/agile/product-management/new-product-development-process",
                    level: 1
                },
                {
                    key: "/agile/product-management/product-management-kpis",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-management-kpis",
                        defaultMessage: "Product management KPIs"
                    }),
                    urlSlug:
                        "/agile/product-management/product-management-kpis",
                    level: 1
                },
                {
                    key: "/agile/product-management/nps-score",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-nps-score",
                        defaultMessage: "Net Promoter Score (NPS)"
                    }),
                    urlSlug: "/agile/product-management/nps-score",
                    level: 1
                },
                {
                    key: "/agile/product-management/product-critique",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-critique",
                        defaultMessage: "Product critique"
                    }),
                    urlSlug: "/agile/product-management/product-critique",
                    level: 1
                },
                {
                    key: "/agile/product-management/prioritization-framework",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-prioritization-framework",
                        defaultMessage: "Prioritization frameworks"
                    }),
                    urlSlug:
                        "/agile/product-management/prioritization-framework",
                    level: 1
                },
                {
                    key: "/agile/product-management/product-features",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-features",
                        defaultMessage: "Product features"
                    }),
                    urlSlug: "/agile/product-management/product-features",
                    level: 1
                },
                {
                    key: "/agile/product-management/product-management-tools",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-management-tools",
                        defaultMessage: "Product management tools"
                    }),
                    urlSlug:
                        "/agile/product-management/product-management-tools",
                    level: 1
                },
                {
                    key: "/agile/product-management/plm",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-plm",
                        defaultMessage: "Product Lifecycle Management"
                    }),
                    urlSlug: "/agile/product-management/plm",
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/roadmap-software",
                    key: "/agile/product-management/roadmap-software",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-roadmap-software",
                        defaultMessage: "9 best roadmap software for teams"
                    }),
                    level: 1
                },
                {
                    urlSlug:
                        "/agile/product-management/product-launch-checklist",
                    key: "/agile/product-management/product-launch-checklist",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-launch-checklist",
                        defaultMessage: "Product launch checklist"
                    }),
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/product-strategy",
                    key: "/agile/product-management/product-strategy",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-strategy",
                        defaultMessage: "Product strategy"
                    }),
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/product-engineering",
                    key: "/agile/product-management/product-engineering",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-engineering",
                        defaultMessage: "Product engineering"
                    }),
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/product-operations",
                    key: "/agile/product-management/product-operations",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-operations",
                        defaultMessage: "Product operations"
                    }),
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/portfolio-management",
                    key: "/agile/product-management/portfolio-management",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-portfolio-management",
                        defaultMessage: "Portfolio management"
                    }),
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/pm-and-ai",
                    key: "/agile/product-management/pm-and-ai",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-pm-and-ai",
                        defaultMessage: "AI and product management"
                    }),
                    level: 1
                },
                {
                    urlSlug:
                        "/agile/product-management/growth-product-management",
                    key: "/agile/product-management/growth-product-management",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-growth-product-management",
                        defaultMessage: "Growth product management"
                    }),
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/product-metrics",
                    key: "/agile/product-management/product-metrics",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-metrics",
                        defaultMessage: "Product metrics"
                    }),
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/product-release",
                    key: "/agile/product-management/product-release",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-release",
                        defaultMessage: "Product release"
                    }),
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/feature-request",
                    key: "/agile/product-management/feature-request",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-feature-request",
                        defaultMessage: "Feature request"
                    }),
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/product-launch",
                    key: "/agile/product-management/product-launch",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-launch",
                        defaultMessage: "Product launch"
                    }),
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/product-planning",
                    key: "/agile/product-management/product-planning",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-planning",
                        defaultMessage: "Product planning"
                    }),
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/product-launch-event",
                    key: "/agile/product-management/product-launch-event",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-launch-event",
                        defaultMessage: "Product launch event"
                    }),
                    level: 1
                }
            ]
        },
        {
            key: "value-stream-management",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.value-stream-management",
                defaultMessage: "Value Stream Management"
            }),
            urlSlug: "/agile/value-stream-management",
            level: 0,
            isRoot: true
        },
        {
            key: "agile-at-scale",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.agile-at-scale",
                defaultMessage: "Agile at scale"
            }),
            urlSlug: "/agile/agile-at-scale",
            level: 0,
            isRoot: true,
            children: [
                {
                    key: "/agile/agile-at-scale",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-at-scale-overview",
                        defaultMessage: "Overview"
                    }),
                    urlSlug: "/agile/agile-at-scale",
                    level: 0
                },
                {
                    key: "/agile/agile-at-scale/managing-an-agile-portfolio",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-at-scale-managing-an-agile-portfolio",
                        defaultMessage: "Managing an agile portfolio"
                    }),
                    urlSlug:
                        "/agile/agile-at-scale/managing-an-agile-portfolio",
                    level: 1
                },
                {
                    key: "/agile/agile-at-scale/lean-portfolio-management",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-at-scale-lean-portfolio-management",
                        defaultMessage: "Lean portfolio management"
                    }),
                    urlSlug: "/agile/agile-at-scale/lean-portfolio-management",
                    level: 1
                },
                {
                    key: "/agile/agile-at-scale/okr",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-at-scale-okr",
                        defaultMessage: "Okrs"
                    }),
                    urlSlug: "/agile/agile-at-scale/okr",
                    level: 1
                },
                {
                    key: "/agile/agile-at-scale/long-term-agile-planning",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-at-scale-long-term-agile-planning",
                        defaultMessage: "Long-term agile planning"
                    }),
                    urlSlug: "/agile/agile-at-scale/long-term-agile-planning",
                    level: 1
                },
                {
                    key: "/agile/agile-at-scale/what-is-safe",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-at-scale-what-is-safe",
                        defaultMessage: "What is SAFe?"
                    }),
                    urlSlug: "/agile/agile-at-scale/what-is-safe",
                    level: 1
                },
                {
                    key: "/agile/agile-at-scale/spotify",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-at-scale-spotify",
                        defaultMessage: "Spotify model"
                    }),
                    urlSlug: "/agile/agile-at-scale/spotify",
                    level: 1
                },
                {
                    key: "/agile/agile-at-scale/scrum-at-scale",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-at-scale-scrum-at-scale",
                        defaultMessage:
                            "Organizational agility with Scrum@Scale"
                    }),
                    urlSlug: "/agile/agile-at-scale/scrum-at-scale",
                    level: 1
                },
                {
                    key: "/agile/agile-at-scale/agile-iron-triangle",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-at-scale-agile-iron-triangle",
                        defaultMessage: "Agile iron triangle"
                    }),
                    urlSlug: "/agile/agile-at-scale/agile-iron-triangle",
                    level: 1
                },
                {
                    key: "/agile/agile-at-scale/less",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-at-scale-less",
                        defaultMessage: "The Large-Scale Scrum (LeSS) framework"
                    }),
                    urlSlug: "/agile/agile-at-scale/less",
                    level: 1
                },
                {
                    key: "/agile/agile-at-scale/using-improvement-kata-to-support-lean",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-at-scale-using-improvement-kata-to-support-lean",
                        defaultMessage: "Using Improvement Kata to support lean"
                    }),
                    urlSlug:
                        "/agile/agile-at-scale/using-improvement-kata-to-support-lean",
                    level: 1
                },
                {
                    key: "/agile/agile-at-scale/beyond-the-basics-whitepaper",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-at-scale-beyond-the-basics-whitepaper",
                        defaultMessage: "Beyond the basics whitepaper"
                    }),
                    urlSlug:
                        "/agile/agile-at-scale/beyond-the-basics-whitepaper",
                    level: 1
                }
            ]
        },
        {
            key: "software-development",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.software-development",
                defaultMessage: "Software development"
            }),
            urlSlug: "/agile/software-development",
            level: 0,
            isRoot: true,
            children: [
                {
                    key: "/agile/software-development",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-overview",
                        defaultMessage: "Overview"
                    }),
                    urlSlug: "/agile/software-development",
                    level: 0
                },
                {
                    key: "/agile/software-development/developer",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-developer",
                        defaultMessage: "Developer"
                    }),
                    urlSlug: "/agile/software-development/developer",
                    level: 1
                },
                {
                    key: "/agile/software-development/dev-managers-vs-scrum-masters",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-dev-managers-vs-scrum-masters",
                        defaultMessage: "Dev managers vs scrum masters"
                    }),
                    urlSlug:
                        "/agile/software-development/dev-managers-vs-scrum-masters",
                    level: 1
                },
                {
                    key: "/agile/software-development/git",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-git",
                        defaultMessage: "Git"
                    }),
                    urlSlug: "/agile/software-development/git",
                    level: 1
                },
                {
                    key: "/agile/software-development/branching",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-branching",
                        defaultMessage: "Branching"
                    }),
                    urlSlug: "/agile/software-development/branching",
                    level: 1
                },
                {
                    key: "/agile/software-development/git-branching-video",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-git-branching-video",
                        defaultMessage: "Git branching video"
                    }),
                    urlSlug: "/agile/software-development/git-branching-video",
                    level: 1
                },
                {
                    key: "/agile/software-development/code-reviews",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-code-reviews",
                        defaultMessage: "Code reviews"
                    }),
                    urlSlug: "/agile/software-development/code-reviews",
                    level: 1
                },
                {
                    key: "/agile/software-development/release",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-release",
                        defaultMessage: "Release"
                    }),
                    urlSlug: "/agile/software-development/release",
                    level: 1
                },
                {
                    key: "/agile/software-development/technical-debt",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-technical-debt",
                        defaultMessage: "Technical debt"
                    }),
                    urlSlug: "/agile/software-development/technical-debt",
                    level: 1
                },
                {
                    key: "/agile/software-development/testing",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-testing",
                        defaultMessage: "Testing"
                    }),
                    urlSlug: "/agile/software-development/testing",
                    level: 1
                },
                {
                    key: "/agile/software-development/incident-response",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-incident-response",
                        defaultMessage: "Incident response"
                    }),
                    urlSlug: "/agile/software-development/incident-response",
                    level: 1
                },
                {
                    key: "/agile/software-development/continuous-integration",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-continuous-integration",
                        defaultMessage: "Continuous integration"
                    }),
                    urlSlug:
                        "/agile/software-development/continuous-integration",
                    level: 1
                },
                {
                    key: "/agile/software-development/sdlc",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-sdlc",
                        defaultMessage: "Sdlc"
                    }),
                    urlSlug: "/agile/software-development/sdlc",
                    level: 1
                },
                {
                    key: "/agile/software-development/bug-triage",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-bug-triage",
                        defaultMessage:
                            "Bug triage: definition, examples, and best practices"
                    }),
                    urlSlug: "/agile/software-development/bug-triage",
                    level: 1
                }
            ]
        },
        {
            key: "design",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.design",
                defaultMessage: "Design"
            }),
            urlSlug: "/agile/design",
            level: 0,
            isRoot: true,
            children: [
                {
                    key: "/agile/design",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.design-overview",
                        defaultMessage: "Overview"
                    }),
                    urlSlug: "/agile/design",
                    level: 0
                },
                {
                    key: "/agile/design/product-design-process-customer-interview",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.design-product-design-process-customer-interview",
                        defaultMessage:
                            "Product design process customer interview"
                    }),
                    urlSlug:
                        "/agile/design/product-design-process-customer-interview",
                    level: 1
                },
                {
                    key: "/agile/design/collaborative-design-in-agile-teams-video",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.design-collaborative-design-in-agile-teams-video",
                        defaultMessage:
                            "Collaborative design in agile teams video"
                    }),
                    urlSlug:
                        "/agile/design/collaborative-design-in-agile-teams-video",
                    level: 1
                }
            ]
        },
        {
            key: "agile-marketing",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.agile-marketing",
                defaultMessage: "Agile marketing"
            }),
            urlSlug: "/agile/agile-marketing",
            level: 0,
            isRoot: true,
            children: [
                {
                    key: "/agile/agile-marketing",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-marketing-overview",
                        defaultMessage: "Overview"
                    }),
                    urlSlug: "/agile/agile-marketing",
                    level: 0
                },
                {
                    key: "/agile/agile-marketing/what-is-agile-marketing",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-marketing-what-is-agile-marketing",
                        defaultMessage: "What is Agile Marketing?"
                    }),
                    urlSlug: "/agile/agile-marketing/what-is-agile-marketing",
                    level: 1
                },
                {
                    key: "/agile/agile-marketing/agile-marketing-team",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-marketing-agile-marketing-team",
                        defaultMessage: "How to create an agile marketing team"
                    }),
                    urlSlug: "/agile/agile-marketing/agile-marketing-team",
                    level: 1
                }
            ]
        },
        {
            key: "advantage",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.advantage",
                defaultMessage: "The agile advantage"
            }),
            urlSlug: "/agile/advantage",
            level: 0,
            isRoot: true,
            children: [
                {
                    key: "/agile/advantage",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.advantage-overview",
                        defaultMessage: "Overview"
                    }),
                    urlSlug: "/agile/advantage",
                    level: 0
                },
                {
                    key: "/agile/advantage/connect-business-strategy-to-development-reality",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.advantage-connect-business-strategy-to-development-reality",
                        defaultMessage:
                            "Connecting business strategy to development reality"
                    }),
                    urlSlug:
                        "/agile/advantage/connect-business-strategy-to-development-reality",
                    level: 1
                },
                {
                    key: "/agile/advantage/agile-is-a-competitive-advantage",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.advantage-agile-is-a-competitive-advantage",
                        defaultMessage: "Agile is a competitive advantage"
                    }),
                    urlSlug:
                        "/agile/advantage/agile-is-a-competitive-advantage",
                    level: 1
                },
                {
                    key: "/agile/advantage/agile-mindset",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.advantage-agile-mindset",
                        defaultMessage: "Cultivating an agile mindset"
                    }),
                    urlSlug: "/agile/advantage/agile-mindset",
                    level: 1
                },
                {
                    key: "/agile/advantage/going-agile",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.advantage-going-agile",
                        defaultMessage: "Going agile"
                    }),
                    urlSlug: "/agile/advantage/going-agile",
                    level: 1
                }
            ]
        },
        {
            key: "devops",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.devops",
                defaultMessage: "DevOps"
            }),
            urlSlug: "/agile/devops",
            level: 0,
            isRoot: true
        },
        {
            key: "teams",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.teams",
                defaultMessage: "Agile Teams"
            }),
            urlSlug: "/agile/teams",
            level: 0,
            isRoot: true,
            children: [
                {
                    key: "/agile/teams",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.teams-overview",
                        defaultMessage: "Overview"
                    }),
                    urlSlug: "/agile/teams",
                    level: 0
                },
                {
                    key: "/agile/teams/remote-teams",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.teams-remote-teams",
                        defaultMessage: "Remote teams"
                    }),
                    urlSlug: "/agile/teams/remote-teams",
                    level: 1
                },
                {
                    key: "/agile/teams/working-with-specialists",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.teams-working-with-specialists",
                        defaultMessage: "Working with specialists"
                    }),
                    urlSlug: "/agile/teams/working-with-specialists",
                    level: 1
                },
                {
                    key: "/agile/teams/release-ready-teams",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.teams-release-ready-teams",
                        defaultMessage: "Release ready teams"
                    }),
                    urlSlug: "/agile/teams/release-ready-teams",
                    level: 1
                },
                {
                    key: "/agile/teams/agilents-agile-transformation-journey",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.teams-agilents-agile-transformation-journey",
                        defaultMessage: "Agilent’s agile transformation journey"
                    }),
                    urlSlug:
                        "/agile/teams/agilents-agile-transformation-journey",
                    level: 1
                },
                {
                    key: "/agile/teams/advanced-roadmaps-teams",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.teams-advanced-roadmaps-teams",
                        defaultMessage: "Advanced Roadmaps"
                    }),
                    urlSlug: "/agile/teams/advanced-roadmaps-teams",
                    level: 1
                },
                {
                    key: "/agile/teams/jira-twitter-unified-projects-teamwork",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.teams-jira-twitter-unified-projects-teamwork",
                        defaultMessage: "How Twitter uses Jira"
                    }),
                    urlSlug:
                        "/agile/teams/jira-twitter-unified-projects-teamwork",
                    level: 1
                },
                {
                    key: "/agile/teams/scrum-kanban-agile",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.teams-scrum-kanban-agile",
                        defaultMessage: "How we chose our agile"
                    }),
                    urlSlug: "/agile/teams/scrum-kanban-agile",
                    level: 1
                }
            ]
        },
        {
            key: "tutorials",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.tutorials",
                defaultMessage: "Agile tutorials"
            }),
            urlSlug: "/agile/tutorials",
            level: 0,
            isRoot: true,
            children: [
                {
                    key: "/agile/tutorials",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-overview",
                        defaultMessage: "Overview"
                    }),
                    urlSlug: "/agile/tutorials",
                    level: 0
                },
                {
                    key: "/agile/tutorials/jira-confluence-sprint-refinement",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-jira-confluence-sprint-refinement",
                        defaultMessage: "Jira and Confluence sprint refinement"
                    }),
                    urlSlug:
                        "/agile/tutorials/jira-confluence-sprint-refinement",
                    level: 1
                },
                {
                    key: "/agile/tutorials/how-to-do-scrum-with-jira",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-how-to-do-scrum-with-jira-software",
                        defaultMessage: "How to do scrum with Jira"
                    }),
                    urlSlug: "/agile/tutorials/how-to-do-scrum-with-jira",
                    level: 1
                },
                {
                    key: "/agile/tutorials/how-to-do-kanban-with-jira",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-how-to-do-kanban-with-jira-software",
                        defaultMessage: "Learn kanban with Jira"
                    }),
                    urlSlug: "/agile/tutorials/how-to-do-kanban-with-jira",
                    level: 1
                },
                {
                    key: "/agile/tutorials/epics",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-epics",
                        defaultMessage: "Learn how to use Epics in Jira"
                    }),
                    urlSlug: "/agile/tutorials/epics",
                    level: 1
                },
                {
                    key: "/agile/tutorials/creating-your-agile-board",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-creating-your-agile-board",
                        defaultMessage:
                            "Learn how to create an agile board in Jira"
                    }),
                    urlSlug: "/agile/tutorials/creating-your-agile-board",
                    level: 1
                },
                {
                    key: "/agile/tutorials/sprints",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-sprints",
                        defaultMessage: "Learn how to use sprints in Jira"
                    }),
                    urlSlug: "/agile/tutorials/sprints",
                    level: 1
                },
                {
                    key: "/agile/tutorials/versions",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-versions",
                        defaultMessage: "Learn Versions with Jira"
                    }),
                    urlSlug: "/agile/tutorials/versions",
                    level: 1
                },
                {
                    key: "/agile/tutorials/issues",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-issues",
                        defaultMessage: "Learn Issues with Jira"
                    }),
                    urlSlug: "/agile/tutorials/issues",
                    level: 1
                },
                {
                    key: "/agile/tutorials/burndown-charts",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-burndown-charts",
                        defaultMessage: "Learn burndown charts with Jira"
                    }),
                    urlSlug: "/agile/tutorials/burndown-charts",
                    level: 1
                },
                {
                    key: "/agile/tutorials/how-to-auto-create-subtasks-with-jira-automation",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-how-to-auto-create-subtasks-with-jira-software-automation",
                        defaultMessage:
                            "Auto-create sub-tasks and update fields in Jira"
                    }),
                    urlSlug:
                        "/agile/tutorials/how-to-auto-create-subtasks-with-jira-automation",
                    level: 1
                },
                {
                    key: "/agile/tutorials/how-to-automatically-assign-issues-with-jira-software-automation",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-how-to-automatically-assign-issues-with-jira-software-automation",
                        defaultMessage:
                            "How to automatically assign issues with Jira Automation"
                    }),
                    urlSlug:
                        "/agile/tutorials/how-to-automatically-assign-issues-with-jira-software-automation",
                    level: 1
                },
                {
                    key: "/agile/tutorials/how-to-sync-epics-stories-with-jira-software-automation",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-how-to-sync-epics-stories-with-jira-software-automation",
                        defaultMessage:
                            "How to sync epics stories with Jira Automation"
                    }),
                    urlSlug:
                        "/agile/tutorials/how-to-sync-epics-stories-with-jira-software-automation",
                    level: 1
                },
                {
                    key: "/agile/tutorials/how-to-escalate-overdue-issues-with-jira-software-automation",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-how-to-escalate-overdue-issues-with-jira-software-automation",
                        defaultMessage:
                            "Automatically escalate overdue issues in Jira"
                    }),
                    urlSlug:
                        "/agile/tutorials/how-to-escalate-overdue-issues-with-jira-software-automation",
                    level: 1
                }
            ]
        },
        {
            key: "agile-conversations",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.agile-conversations",
                defaultMessage: "Agile conversations"
            }),
            urlSlug: "/agile/agile-conversations",
            level: 0,
            isRoot: true,
            children: [
                {
                    key: "/agile/agile-conversations",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-conversations-overview",
                        defaultMessage: "Overview"
                    }),
                    urlSlug: "/agile/agile-conversations",
                    level: 0
                },
                {
                    key: "/agile/agile-conversations/marketing-agility",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-conversations-marketing-agility",
                        defaultMessage: "Unlocking marketing agility"
                    }),
                    urlSlug: "/agile/agile-conversations/marketing-agility",
                    level: 1
                },
                {
                    key: "/agile/agile-conversations/customer-research-tips",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-conversations-customer-research-tips",
                        defaultMessage:
                            "The power of agile and customer insights"
                    }),
                    urlSlug:
                        "/agile/agile-conversations/customer-research-tips",
                    level: 1
                },
                {
                    key: "/agile/agile-conversations/think-big-work-small",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-conversations-think-big-work-small",
                        defaultMessage: "Think big, work small"
                    }),
                    urlSlug: "/agile/agile-conversations/think-big-work-small",
                    level: 1
                }
            ]
        },
        {
            key: "about",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.about",
                defaultMessage: "About the Agile Coach"
            }),
            urlSlug: "/agile/about",
            level: 0,
            isRoot: true,
            children: [
                {
                    key: "/agile/about",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.about-overview",
                        defaultMessage: "Overview"
                    }),
                    urlSlug: "/agile/about",
                    level: 0
                },
                {
                    key: "/agile/about/dan-radigan",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.about-dan-radigan",
                        defaultMessage: "Dan Radigan"
                    }),
                    urlSlug: "/agile/about/dan-radigan",
                    level: 1
                },
                {
                    key: "/agile/about/max-rehkopf",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.about-max-rehkopf",
                        defaultMessage: "Max Rehkopf"
                    }),
                    urlSlug: "/agile/about/max-rehkopf",
                    level: 1
                },
                {
                    key: "/agile/about/claire-drumond",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.about-claire-drumond",
                        defaultMessage: "Claire Drumond"
                    }),
                    urlSlug: "/agile/about/claire-drumond",
                    level: 1
                },
                {
                    key: "/agile/about/laura-daly",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.about-laura-daly",
                        defaultMessage: "Laura Daly"
                    }),
                    urlSlug: "/agile/about/laura-daly",
                    level: 1
                },
                {
                    key: "/agile/about/sherif-mansour",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.about-sherif-mansour",
                        defaultMessage: "Sherif Mansour"
                    }),
                    urlSlug: "/agile/about/sherif-mansour",
                    level: 1
                },
                {
                    key: "/agile/about/martin-suntinger",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.about-martin-suntinger",
                        defaultMessage: "Martin Suntinger"
                    }),
                    urlSlug: "/agile/about/martin-suntinger",
                    level: 1
                }
            ]
        },
        {
            key: "articles",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.articles",
                defaultMessage: "All articles"
            }),
            urlSlug: "/agile/articles",
            level: 0,
            isRoot: true
        }
    ];
    return AgileHubPageTreeData;
};
